import styled from "styled-components";
import theme from "../../../theme";

export const Content = styled.div``;

export const Container = styled.div`
  width: 70%;
  padding: 20px 10px;
  .submit {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .submit-buttons {
      display: flex;
      gap: 10px;
      .cancel,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid ${theme.color.brandDark};
        background-color: ${theme.color.brandDark};
      }
    }
  }

  @media screen and (max-width: 820px) {
    width: 100%;
  }
`;
export const FormWrapper = styled.div`
  @media screen and (max-width: 820px) {
    grid-template-columns: repeat(1, 1fr);
    border: none;
    padding: 5px;
    gap: 5px;
  }

  padding: 25px 10px;
  border-bottom: 1px solid #e0e2e6;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  label {
    margin-top: 20px;
    color: #344054;
    font-size: 14px;
  }
  p {
    margin-top: 5px;
    font-size: 14px;
    color: #667085;
  }
  .date {
    display: flex;
    gap: 10px;
  }

  input[type="text"],
  input[type="file"],
  input[type="date"],
  input[type="number"] {
    width: 100%;
    //height: 43px;
    margin-top: 10px;
    border: solid 1px #e0e2e6;
    border-radius: 10px;
    padding: 12px 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: #027f7f;
      border: 1px solid ${theme.color.brandDark};
      background: transparent;
    }
  }
`;

export const RadioGroup = styled.div`
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  padding: 10px 16px 24px 16px;
`;

export const RadioButton = styled.input`
  display: none;

  &:checked + label {
    background-color: #eefffc;
    border-color: #33615a;
    .circle {
      background-color: ${theme.color.brandDark};
      img {
        display: block;
        width: 8px;
        height: 10px;
        margin: auto;
        margin-top: 2px;
        transform: scale(1);
        justify-content: center;
        align-items: center;
      }
    }
  }

  &:disabled + label {
    color: #ccc;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  .label-name {
    display: flex;
    gap: 10px;
    p {
      margin-top: 5px;
    }
  }
  img {
    width: 28px;
    height: 28px;
  }
  .circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    margin-right: 10px;
    transition: background-color 0.2s ease-in-out;
    img {
      display: none;
    }
  }
`;

export const ProofOfPaymentContainer = styled.div`
  border: 1px solid #d0d5dd;
  padding: 20px;
  text-align: center;
  border-radius: 5px;
`;

export const FileInputLabel = styled.label`
  display: block;
  cursor: pointer;
  .text {
    margin-top: -15px;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  border-radius: 5px;
`;

export const Details = styled.div`
  width: 100%;
  padding: 10px;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  .wrapper {
    display: flex;
    justify-content: space-between;
    padding: 5px 0px;

    label {
      font-size: 10px;
      color: #989fad;
      line-height: 14px;
    }

    p {
      font-size: 14px;
      color: #2b2f38;
      line-height: 18px;
    }
    img {
      cursor: pointer;
    }
  }
`;
